<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab v-if="crud.assortment_id"
                     value="1">{{ __('Products') }}</Tab>
                <Tab value="2">{{ __('Attachments') }}</Tab>
                <Tab value="3">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="offer_name"
                                       label="Offer name"
                                       validation="required"
                                       size="4"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.offer_name" />
                        <FormInputText fieldName="offer_title"
                                       label="Offer title"
                                       size="5"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.offer_title" />
                        <FormSelect fieldName="status_id"
                                    label="Status"
                                    size="3"
                                    :isFormDisabled="true"
                                    :options="select?.statuses"
                                    v-model:field="crud.status_id" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="opportunity_id"
                                    label="Sale opportunity"
                                    size="3"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled || isOpportunityDisabled"
                                    :options="select?.opportunities"
                                    :change="(e) => changeOpportunityRooms(e)"
                                    v-model:field="crud.opportunity_id" />
                        <FormSelect fieldName="assortment_id"
                                    label="Assortment"
                                    size="4"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled || isOpportunityDisabled"
                                    :options="select?.assortments"
                                    :change="(e) => changeProductsForSelectedAssortment(e.value)"
                                    v-model:field="crud.assortment_id" />

                        <FormSelect fieldName="creator_id"
                                    label="Creator"
                                    size="3"
                                    :isFormDisabled="true"
                                    :options="select?.users"
                                    v-model:field="crud.creator_id" />

                        <FormInputText fieldName="offer_number"
                                       label="Number"
                                       size="2"
                                       :isFormDisabled="true"
                                       v-model:field="crud.offer_number" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="contact1_id"
                                    label="Contact 1"
                                    size="3"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.users"
                                    v-model:field="crud.contact1_id" />

                        <FormSelect fieldName="contact2_id"
                                    label="Contact 2"
                                    size="3"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.users"
                                    v-model:field="crud.contact2_id" />

                        <FormCalendar fieldName="creation_date"
                                      label="Creation date"
                                      size="2"
                                      validation="required"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.creation_date" />

                        <FormCalendar fieldName="valid_to"
                                      label="Valid to"
                                      size="2"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.valid_to" />

                        <FormInputNumber fieldName="overhead"
                                         label="Overhead"
                                         size="2"
                                         :minFractionDigits="0"
                                         :maxFractionDigits="0"
                                         :suffix="'%'"
                                         :min="0"
                                         :max="100"
                                         :isFormDisabled="isFormDisabled"
                                         :blur="() => handleRecalculateTotalPriceForAllRows()"
                                         v-model:field="crud.overhead" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="delivery_address"
                                       label="Delivery address"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.delivery_address" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.assortment_id"
                          value="1">
                    <div class="grid">
                        <!-- Przycisk dodania sekcji -->
                        <CustomButton name="addSection"
                                      :className="buttonClass('blue')"
                                      @click="addSection(sectionIdx)">
                            <template class="flex items-center gap-1"><i class="fa-solid fa-puzzle-piece"></i><span>{{ __('Add section') }}</span></template>
                        </CustomButton>

                        <!-- Pętla po sekcjach -->
                        <div name="offer_sections"
                             style="height:0"></div>
                        <div v-for="(section, sectionIdx) in crud.offer_sections"
                             :key="sectionIdx"
                             class="w-full mb-4 border border-gray-300 rounded p-3">

                            <!-- Nagłówek sekcji -->
                            <div class="flex items-center gap-3 mb-2">
                                <label class="font-semibold text-gray-700">{{ __('Section name') }}:</label>
                                <FormInputText style="margin-bottom:7px;"
                                               inputClass="required-field"
                                               :fieldName="'offer_sections.' + sectionIdx + '.section_name'"
                                               :isFormDisabled="isFormDisabled"
                                               v-model:field="section.section_name" />
                                <Button v-if="!isFormDisabled"
                                        icon="pi pi-trash"
                                        class="p-button-danger p-button-sm"
                                        @click="removeSection(sectionIdx)" />
                            </div>
                            <div :name="'offer_sections.' + sectionIdx + '.offer_products'"
                                 style=""></div>


                            <FormRepeaterTable v-model:record="section.offer_products"
                                               :keys="{ 'product_id': null, 'room_name': null, 'is_individual_order': true, 'price': null, 'discount': null, 'unit': null, 'quantity': null, 'total': null, 'description': null, 'picture': null, 'files': {} }"
                                               :isFirstRowEmpty="false"
                                               :isCopyButton="false"
                                               :addButtonName="__('Add product')"
                                               repeaterStyle="margin-top:13px;width:100%"
                                               :name="'offer_products_' + sectionIdx"
                                               :title="[__('Product'), __('Room'), __('Ind. order'), __('Price'), __('Discount'), __('Unit'), __('Quantity'), __('Total'), __('Description'), __('Picture'), __('Files')]">

                                <template #repeat="slotProps">
                                    <td style="width:25%;"
                                        :style="slotProps.cellStyle">
                                        <FormAutocomplete fieldName="product_id"
                                                          inputClass="required-field"
                                                          :inRepeater="true"
                                                          :options="filteredProducts"
                                                          :filter="onFilterProducts"
                                                          :change="(e) => insertProductDataIntoRow(e, slotProps.record)"
                                                          v-model:field="slotProps.record.product_id" />
                                    </td>
                                    <td style="width:13%"
                                        :style="slotProps.cellStyle">
                                        <FormSelect fieldName="room"
                                                    :inRepeater="true"
                                                    :options="rooms?.opportunityrooms"
                                                    v-model:field="slotProps.record.room" />

                                    </td>
                                    <td style="width:1%"
                                        :style="slotProps.cellStyle">
                                        <FormInputToggleButton fieldName="is_individual_order"
                                                               style="margin-top:-9px"
                                                               :inRepeater="true"
                                                               v-model:field="slotProps.record.is_individual_order" />
                                    </td>
                                    <td style="width:5%"
                                        :style="slotProps.cellStyle">
                                        <FormInputNumber fieldName="price"
                                                         class="required-field"
                                                         :inRepeater="true"
                                                         :minFractionDigits="2"
                                                         :maxFractionDigits="2"
                                                         :blur="() => handleCalculateTotalPrice(slotProps.record)"
                                                         v-model:field="slotProps.record.price" />
                                    </td>
                                    <td style="width:4%"
                                        :style="slotProps.cellStyle">
                                        <FormInputNumber fieldName="discount"
                                                         :inRepeater="true"
                                                         :minFractionDigits="0"
                                                         :maxFractionDigits="0"
                                                         :suffix="'%'"
                                                         :min="0"
                                                         :max="100"
                                                         :blur="() => handleCalculateTotalPrice(slotProps.record)"
                                                         v-model:field="slotProps.record.discount" />
                                    </td>
                                    <td style="width:5%"
                                        :style="slotProps.cellStyle">
                                        <FormSelect fieldName="unit_id"
                                                    :inRepeater="true"
                                                    :options="select?.units"
                                                    :isFormDisabled="!isNullish(slotProps.record.unit_id)"
                                                    v-model:field="slotProps.record.unit_id" />
                                    </td>
                                    <td style="width:4%"
                                        :style="slotProps.cellStyle">
                                        <FormInputNumber fieldName="quantity"
                                                         class="required-field"
                                                         :inRepeater="true"
                                                         :minFractionDigits="2"
                                                         :maxFractionDigits="2"
                                                         :blur="() => handleCalculateTotalPrice(slotProps.record)"
                                                         v-model:field="slotProps.record.quantity" />
                                    </td>
                                    <td style="width:7%"
                                        :style="slotProps.cellStyle">
                                        <FormInputNumber fieldName="total"
                                                         :inRepeater="true"
                                                         :minFractionDigits="2"
                                                         :maxFractionDigits="2"
                                                         v-model:field="slotProps.record.total" />
                                    </td>
                                    <td style="width:15%"
                                        :style="slotProps.cellStyle">
                                        <FormTextarea fieldName="description"
                                                      :inRepeater="true"
                                                      :rows="3"
                                                      v-model:field="slotProps.record.description" />
                                    </td>
                                    <td style="width:10%"
                                        :style="slotProps.cellStyle">
                                        <span>
                                            <img v-if="slotProps.record.picture"
                                                 style="width:100px;height:100px;object-fit:cover;"
                                                 :src="slotProps.record.picture" />
                                        </span>
                                    </td>

                                    <td style="width:10%;border-width:1px;">
                                        <FormFileUploader fieldName="files"
                                                          category="pictures"
                                                          imgPosition="left"
                                                          :inRepeater="true"
                                                          :isShortNames="true"
                                                          :showSizeInfo="false"
                                                          :allowedExtensions="['jpg', 'jpeg', 'png', 'gif']"
                                                          :style="{ marginTop: '18px', minWidth: '100px', display: 'flex', flexDirection: 'column-reverse' }"
                                                          v-model:field="slotProps.record.files" />
                                    </td>
                                </template>
                            </FormRepeaterTable>
                        </div>
                    </div>
                </TabPanel>

                <TabPanel value="2">
                    <div class="grid">
                        <FormFileUploader fieldName="files"
                                          label="Documents"
                                          category="documents"
                                          :allowedExtensions="['pdf', 'docx', 'xlsx', 'txt']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                        <FormFileUploader fieldName="files"
                                          label="Pictures"
                                          category="pictures"
                                          imgPosition="right"
                                          :allowedExtensions="['jpg', 'jpeg', 'png', 'gif']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="3"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="formProps.buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
                <template #after-in-show="buttonProps">
                    <span style="margin-right:25px"></span>
                    <span v-if="!isReadyToOrder">
                        <CustomButton name="setReadyToOrder"
                                      @click.stop="isReadyToOrderStatusConfirmationOpen = true"
                                      :buttonProps="buttonProps"
                                      :className="buttonClass('blue')">
                            <template class="flex items-center gap-1"><i class="fa-solid fa-list-ol"></i><span>{{ __('Ready to order') }}</span></template>
                        </CustomButton>
                    </span>
                    <span>
                        <CustomButton name="printIntoExcel"
                                      :buttonProps="buttonProps"
                                      :click="() => printIntoExcel()"
                                      :className="buttonClass('orange')">
                            {{ __('Print') }}
                        </CustomButton>
                    </span>
                </template>

                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>

        <AlertAdd :formProps="{ source_table: 'offers', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>

    <ConfirmDialog header="Confirm operation"
                   question="Do you want to set Ready to order status?"
                   v-model="isReadyToOrderStatusConfirmationOpen"
                   :operation="setReadyToOrderStatus">
    </ConfirmDialog>

</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { router } from '@inertiajs/vue3';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormAutocomplete from '@crud/FormAutocomplete.vue'
import FormInputToggleButton from '@crud/FormInputToggleButton.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormRepeaterTable from '@crud/FormRepeaterTable.vue'
import FormTextarea from '@crud/FormTextarea.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormFileUploader from '@crud/FormFileUploader.vue'
import FormButtons from '@crud/FormButtons.vue'
import Button from 'primevue/button'
import CustomButton from '@crud/CustomButton.vue'
import ConfirmDialog from '@crud/ConfirmDialog.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import { __, getStoreValue, getStatusId, currentDate, getFromRoute, buttonClass, screenMessage, printReport, isNullish } from '@helper/utils.js'
import { validation, initFormObj, onFilterService, prepareSelect } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
    opportunityData: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const buttonsVisibility = ref({})

const options = ["statuses", "opportunities", "users", "products", "assortments", "units"];
const select = ref(null);
const rooms = ref([]);  // Lista pokoi kontrahenta
const allProducts = ref([]);
const filteredProducts = ref([]);
const isAddAlertDialogOpen = ref(false);
const isOpportunityDisabled = ref(false);
const isReadyToOrderStatusConfirmationOpen = ref(false);
const isReadyToOrder = ref(false);
//const isCreateOfferModalOpen = defineModel('isCreateOfferModalOpen')

// -----------------------------------------------------

onMounted(async () => {
    await initFormObj({ props, crud, isLoading, options, select, buttonsVisibility, paramsToSelect: { 'statuses': { 'status_category': 'STA_OFFER' } } })
    rooms.value = await prepareSelect('opportunityrooms', null, null, { 'opportunityrooms': { 'opportunity_id': crud.value?.opportunity_id } })

    isReadyToOrder.value = crud.value.status_id === await getStatusId('STA_OFFER', 'SYM_READY_TO_ORDER');
    // === NOWE: Zbierz zapisane product_id z zagnieżdżonej struktury ===
    const savedProductIds = [];
    crud.value?.offer_sections?.forEach(section => {
        if (section.offer_products && Array.isArray(section.offer_products)) {
            section.offer_products.forEach(row => {
                if (row.product_id) {
                    savedProductIds.push(row.product_id);
                }
            });
        }
    });
    if (savedProductIds.length > 0) {
        crud.value.product_id = savedProductIds; // to pole trafi do backendu przez clearCrud
    }

    await changeProductsForSelectedAssortment(crud.value.assortment_id); // Inicjalne ustawienie listy produktów (wszystkie produkty, ponieważ nie ma jeszcze wybranego asortymentu)
    // Ustaw zdjęcia dla już wybranych produktów w tabeli po otwarciu formularza
    crud.value?.offer_sections?.forEach(section => {
        if (section.offer_products && Array.isArray(section.offer_products)) {
            section.offer_products.forEach(row => {
                if (row.product_id) {
                    insertProductDataIntoRow({ value: row.product_id }, row);
                }
            });
        }
    });

    if (props.formProps.addMode == true) {
        crud.value.offer_sections = [];
        crud.value.creator_id = getStoreValue('myId');
        crud.value.status_id = await getStatusId('STA_OFFER', 'SYM_REGISTERED');
        crud.value.creation_date = currentDate();

        if (props.opportunityData) {
            crud.value.opportunity_id = props.opportunityData.id
            crud.value.offer_name = props.opportunityData.opportunity_name
        }

        addDefaultValidToDate()
    }
    if (props.formProps.viewParams?.opportunity_id) {
        crud.value.opportunity_id = props.formProps.viewParams.opportunity_id;
        isOpportunityDisabled.value = true;
    }
})

// -----------------------------------------------------
// Dodaj sekcję
const addSection = () => {
    if (!crud.value.offer_sections) crud.value.offer_sections = [];
    crud.value.offer_sections.push({ section_name: '', offer_products: [] });
};

// -----------------------------------------------------

// Usuń sekcję
const removeSection = (idx) => {
    crud.value.offer_sections.splice(idx, 1);
};

// -----------------------------------------------------

const handleCalculateTotalPrice = (record) => {
    nextTick(() => {
        calculateTotalPrice(record);
    });
};

// -----------------------------------------------------

const handleRecalculateTotalPriceForAllRows = () => {
    nextTick(() => {
        const overhead = parseFloat(crud.value.overhead) || 0;
        if (crud.value.offer_sections) {
            crud.value.offer_sections.forEach(section => {
                if (section.offer_products) {
                    section.offer_products.forEach(row => {
                        calculateTotalPrice(row, overhead);
                    });
                }
            });
        }
    });
};

// -----------------------------------------------------

const calculateTotalPrice = (record, overhead = null) => {
    const quantity = parseFloat(record.quantity) || 0;
    const discount = parseFloat(record.discount) || 0;
    let price = parseFloat(record.price) || 0;

    if (overhead !== null) {
        const basePrice = record._basePrice ?? price;  // ← zawsze od ceny bazowej z DB!
        price = basePrice * (1 + overhead / 100);
        record.price = price.toFixed(2); // Aktualizacja ceny w wierszu po uwzględnieniu narzutu
    }

    if (discount) {
        record.total = ((price * quantity) * (1 - discount / 100)).toFixed(2);
    } else {
        record.total = (price * quantity).toFixed(2);
    }
    if (record.total < 0) {
        record.total = 0;
    }
}

// -----------------------------------------------------

const enrichProductsWithPictures = async (products) => {
    if (!products?.length) return [];
    const response = await getFromRoute('product-pictures', {
        products: products.reduce((acc, p) => {
            acc[p.value] = { label: p.label, part_number: p.part_number, features: p.features };
            return acc;
        }, {})
    }, 'post');
    return products.map(p => {
        const enriched = response.labels[p.value];
        return { ...p, label: enriched || p.label, picture: response.pictures[p.value] || null };
    });
};

// -----------------------------------------------------

const changeProductsForSelectedAssortment = async (assortmentId) => {
    const params = {};
    if (assortmentId) {
        params['products'] = { assortment_id: assortmentId };
    }
    // Pobierz produkty z backendu (z filtrowaniem po assortment_id)
    const data = await prepareSelect('products', null, crud, params);
    select.value.products = data.products || [];

    // Wzbogać o zdjęcia (tak jak dotychczas)
    select.value.products = await enrichProductsWithPictures(select.value.products || []);

    allProducts.value = [...select.value.products];  // zapisz pełną listę
    filteredProducts.value = [...select.value.products];  // inicjalnie to samo
}

// -----------------------------------------------------

const insertProductDataIntoRow = (e, rowData) => {
    const selectedProduct = filteredProducts.value.find(p => p.value === e.value) || allProducts.value.find(p => p.value === e.value);
    if (selectedProduct) {
        rowData._basePrice = selectedProduct.price;  // ← ZAWSZE zapisuj cenę bazową z DB
        if (!rowData.price) {
            rowData.price = selectedProduct.price * (1 + (crud.value.overhead || 0) / 100); // uwzględnij narzut
        }
        if (!rowData.unit_id) {
            rowData.unit_id = selectedProduct.unit_id;
        }
        if (!rowData.picture) {
            rowData.picture = selectedProduct.picture;
        }
    }
}

// -----------------------------------------------------

const setReadyToOrderStatus = async () => {
    const response = await getFromRoute('offer-set-ready-to-order', { offer_id: crud.value.id }, 'post');
    if (response.success) {
        const message = {
            message: response.message,
            title: "Success",
            type: "success",
            position: "center",
            timeout: 5,
        };
        screenMessage(message);
        crud.value.status_id = response.new_status_id; // Aktualizacja statusu w formularzu
    } else {
        const message = {
            message: response.message || "An error occurred",
            title: "Error",
            type: "error",
            position: "center",
            timeout: 5,
        };
        screenMessage(message);
    }

    props.formProps.closeModal();
    props.formProps.getLazyData();
}

// -----------------------------------------------------

const onFilterProducts = async (event) => {
    const params = {};
    if (crud.value.assortment_id) {
        params['products'] = { assortment_id: crud.value.assortment_id };
    }
    const adaptedEvent = { value: event.query };
    await onFilterService(adaptedEvent, 'products', select, isLoading, crud, params);

    // Wyniki z backendu + zdjęcia
    const backendResults = await enrichProductsWithPictures(select.value.products || []);

    // ID produktów pasujących do filtra
    const matchingIds = new Set(backendResults.map(p => p.value));

    // ID produktów już wybranych we wszystkich wierszach
    const selectedIds = new Set();
    crud.value?.offer_sections?.forEach(section => {
        section.offer_products?.forEach(row => {
            if (row.product_id) selectedIds.add(row.product_id);
        });
    });

    // Scalona mapa: allProducts mają priorytet (stabilne referencje!)
    const mergedMap = new Map();
    for (const p of allProducts.value) mergedMap.set(p.value, p);
    for (const p of backendResults) {
        if (!mergedMap.has(p.value)) mergedMap.set(p.value, p);
    }

    // Finalna lista: pasujące do filtra LUB już wybrane
    filteredProducts.value = [];
    for (const [id, product] of mergedMap) {
        if (matchingIds.has(id) || selectedIds.has(id)) {
            filteredProducts.value.push(product);
        }
    }

    // Przywróć pełną listę
    select.value.products = [...allProducts.value];
};

// -----------------------------------------------------

const changeOpportunityRooms = async (e) => {
    if (e.value) {
        rooms.value = await prepareSelect('opportunityrooms', null, null, { 'opportunityrooms': { 'opportunity_id': e.value } });
    } else {
        rooms.value = [];
    }
}

// -----------------------------------------------------

const printIntoExcel = async () => {
    isLoading.value = true;
    const response = await getFromRoute('offer-print', { 'offer_id': crud.value.id }, 'post')
    printReport(response)
    isLoading.value = false;
}

// -----------------------------------------------------

const addDefaultValidToDate = () => {
    if (!crud.value.valid_to && crud.value.creation_date) {
        const defaultValidToDate = new Date(crud.value.creation_date) ?? new Date();
        defaultValidToDate.setMonth(defaultValidToDate.getMonth() + 1);
        crud.value.valid_to = defaultValidToDate.toISOString().split('T')[0];
    }
}

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------


</script>

<style lang="scss" scoped></style>
